import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var channelDetailRoute = [{
  path: "channel-detail/:activeIndex/:cindex",
  name: "channel-detail",
  component: function component() {
    return import("./channel-detail.vue");
  }
}];